<template>
  <div style="height: 100%; width: 100%">
    <audio id="myAudio" preload="meta">
      <source src="@/assets/notification.mp3" type="audio/mpeg" />
      Your browser does not support the audio element.
    </audio>
    <audio id="orderAudio" preload="meta">
      <source src="@/assets/order-noti.mp3" type="audio/mpeg" />
      Your browser does not support the audio element.
    </audio>
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    window.postMessage("pause", "*");
    Print.postMessage("pause");
  },
};
</script>

<style>
:root {
  --primaryColor: #fddf00;
}

@media only screen and (min-width: 992px) {
  .hidden-lg-and-up {
    display: none !important;
  }
}

@media only screen and (max-width: 992px) {
  .hidden-md-and-down {
    display: none !important;
  }
}

@media only screen and (max-width: 1264px) {
  .hidden-lg-and-down {
    display: none !important;
  }
}
</style>
